/* eslint-disable no-lone-blocks */
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { axiosInstance } from "../config/https";
import Header from "../layout/header";
import { toast } from "react-toastify";

const Home = () => {
  const [uniqueid, setUniqueid] = useState("");
  const [loader, setLoader] = useState(false);
  const navigate = useNavigate("");
  const Searchuser = (e) => {
    e.preventDefault();
    setLoader(true);
    axiosInstance
      .get(`users/${uniqueid}`)
      .then((response) => {
        if (response.data.status === true) {
          setLoader(false);
          if (response.data.data !== null) {
            navigate(`detail/${response.data.data.unique_id}`);
          } else {
            toast.error("No Data Found");
          }
        } else {
          setLoader(false);
        }
      })
      .catch((error) => {
        setLoader(false);
        console.log(error);
      });
  };
  const logo = require("../assets/img/logo/logo.png");
  return (
    <>
      {loader ? <div className="loader"></div> : null}
      <div className="bg-cover">
        <Header bg="bg-transparent" />
        <div className="container p-5">
          <div className="text-center">
            <img src={logo} alt="" width={200} />
          </div>

          <div className="row">
            <div className="col-md-2 col-sm-0" />
            <div className="col-md-8 col-sm-12">
              <form className="d-flex" role="search" onSubmit={Searchuser}>
                <div class="input-group mb-3">
                  <input
                    type="search"
                    class="form-control form-control-lg bg-transparent text-white"
                    placeholder="Search FFE using Unique Id..."
                    // aria-label="Recipient's username"
                    aria-describedby="button-addon2"
                    onChange={(e) => setUniqueid(e.target.value)}
                  />
                  <button
                    class="btn btn-outline-primary bg"
                    type="submit"
                    id="button-addon2"
                  >
                    Search
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;

{
  // searchCard
  /* <div className="container my-3">
            <div className="row">
              {displayedUsers.length > 0 ? (
                <div className="row">
                  {displayedUsers
                    .filter((s) => s.status === 1)
                    .map((e, index) => (
                      <div
                        className="col-12 col-sm-6 col-md-4 col-lg-3"
                        key={index}
                      >
                        <Link to={`/Detail/${e.unique_id}`}>
                          <div className="our-team">
                            <div className="picture">
                              <img
                                className="img-fluid"
                                alt=""
                                src={e?.image}
                              />
                            </div>
                            <div className="team-content">
                              <h3 className="name">
                                {e?.fname} {e?.lname}
                              </h3>
                              <h4 className="title">{e?.country}</h4>
                            </div>
                          </div>
                        </Link>
                      </div>
                    ))}
                </div>
              ) : (
                <p>No User found</p>
              )}
              }
            </div>
          </div> */
}
